
$(document).ready(function () {

    $('.product-detail__slider_for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.product-detail__slider_nav'
    });
    $('.product-detail__slider_nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product-detail__slider_for',
        dots: false,
        focusOnSelect: true,
        prevArrow: '<button type="button" class="prev_arrow"><svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.5833 32.0834L5 17.5L19.5833 2.91669L22.1719 5.50523L10.1771 17.5L22.1719 29.4948L19.5833 32.0834Z" fill="#004542" stroke="#004542" stroke-width="3"/></svg></button> ',
        nextArrow: '<button type="button" class="next_arrow"><svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4167 32.0834L30 17.5L15.4167 2.91669L12.8281 5.50523L24.8229 17.5L12.8281 29.4948L15.4167 32.0834Z" fill="#004542" stroke="#004542" stroke-width="3"/></svg></button>',
    });


    // Increase Decrease Count 
    // $('.quantity').on('click', '.plus', function (e) {
    //     let $input = $(this).prev('input.qty');
    //     let val = parseInt($input.val());
    //     $input.val(val + 1).change();
    // });

    // $('.quantity').on('click', '.minus', function (e) {
    //     let $input = $(this).next('input.qty');
    //     var val = parseInt($input.val());
    //     if (val > 0) {
    //         $input.val(val - 1).change();
    //     }
    // });

    // product-collection slider 
    $('.product-collection__slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="prev_arrow"><svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.5833 32.0834L5 17.5L19.5833 2.91669L22.1719 5.50523L10.1771 17.5L22.1719 29.4948L19.5833 32.0834Z" fill="#004542" stroke="#004542" stroke-width="3"/></svg></button> ',
        nextArrow: '<button type="button" class="next_arrow"><svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4167 32.0834L30 17.5L15.4167 2.91669L12.8281 5.50523L24.8229 17.5L12.8281 29.4948L15.4167 32.0834Z" fill="#004542" stroke="#004542" stroke-width="3"/></svg></button>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true
                }
            }
        ]
    });
    // var productCollectionSlider = {
    //     dots: false,
    //     arrows: true,
    //     infinite: true,
    //     autoplay: false,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     prevArrow: '<button type="button" class="prev_arrow"><svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.5833 32.0834L5 17.5L19.5833 2.91669L22.1719 5.50523L10.1771 17.5L22.1719 29.4948L19.5833 32.0834Z" fill="#004542" stroke="#004542" stroke-width="3"/></svg></button> ',
    //     nextArrow: '<button type="button" class="next_arrow"><svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4167 32.0834L30 17.5L15.4167 2.91669L12.8281 5.50523L24.8229 17.5L12.8281 29.4948L15.4167 32.0834Z" fill="#004542" stroke="#004542" stroke-width="3"/></svg></button>',
    //     responsive: [
    //         {
    //             breakpoint: 992,
    //             settings: {
    //                 slidesToShow: 2,
    //                 slidesToScroll: 1,
    //                 infinite: true,
    //             }
    //         },
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 arrows: true,
    //             }
    //         },
    //         {
    //             breakpoint: 576,
    //             settings: {
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 arrows: true
    //             }
    //         }
    //     ]
    // }
    // $('.product-collection__slider').not(".slick-initialized").slick(productCollectionSlider);
    // end product-collection slider 


    $('.accordion > li:first-child').addClass('active');
    $('.accordion > li.active .ans').slideDown();

    $('.accordion h2').click(function () {
        var dropDown = $(this).closest('li').find('.ans');

        $(this).closest('.accordion').find('.ans').not(dropDown).slideUp();

        if ($(this).parent("li").hasClass('active')) {
            $(this).parent("li").removeClass('active');
        } else {
            $(this).closest('.accordion').find('li.active').removeClass('active');
            $(this).parent("li").addClass('active');
        }

        dropDown.stop(false, true).slideToggle();

    });


    // blog metch height
    $('.blog__item_title').matchHeight({
        byRow: 0,
    });
    $('.blog__item_desc').matchHeight({
        byRow: 0,
    });
    // end blog metch height



});
       
   
